/* global rp$, window */
'use strict';

const get = require('lodash/get');

import './dealer_selection_modal.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const { validatePostalCode } = require('public/js/lib/postal-code-helper');

	/********************************************
	 * Load Javascript for Dealer Selection Modal Module
	 * -----------------------------------------
	 * @section dealer_selection_modal_js
	 ********************************************/
	(function DealerSelectionModalModule() {
		let $enterZipButton,
			$dealerSelectionModalTrigger,
			$dealerSelectionModal,
			$dealerSelectionError,
			$formErrors,
			$selectedDealerContainer,
			$dealerSelectionContainer,
			$dealersListContainer,
			$zipInput,
			$modalBody,
			$changeDealerWarning,
			$dealerConfirmSection,
			$dealerSelectionSection,
			$dealerConfirmationFooter,
			$dealerConfirmCancel,
			$dealerConfirmSubmit,
			$cartContentList,
			$productPurchaseModule;

		function clearError() {
			$formErrors.html('');
		}

		// -- Zip Submission Container --
		function zipSubmissionWorking() {
			$enterZipButton.addClass('disabled');
			$dealerSelectionContainer.addClass('show loading');
		}

		function zipSubmissionReady() {
			$enterZipButton.removeClass('disabled');
			$dealerSelectionContainer.removeClass('loading');
		}

		function handleZipSubmissionSuccess(data) {
			if (data) {
				clearError();
				zipSubmissionReady();
				$zipInput.val(data.postal_code_value);
				$selectedDealerContainer.html(data.selected_dealer_html);
				$dealersListContainer.html(data.dealer_list_html);
			}
		}

		function handleZipSubmissionError(errorMessage) {
			$formErrors.html(`${errorMessage}`);
			zipSubmissionReady();
		}

		function handleZipSubmission(e, isAutomaticSubmission) {

			let skuStripped = null;
			let catalog = null;

			if ($productPurchaseModule && $productPurchaseModule.length > 0) {
				skuStripped = $productPurchaseModule.data('sku-stripped');
				catalog = $productPurchaseModule.data('catalog');
			}

			e && e.preventDefault();

			if (rp$(this).hasClass('disabled')) {
				return;
			}

			const postalCode = $zipInput.val();
			if (e && !validatePostalCode(postalCode)) {
				return handleZipSubmissionError($modalBody.data('error-invalid-zip'));
			}

			clearError();

			// Perform Submission
			zipSubmissionWorking();
			window.rp_app.request({
				method: 'GET',
				url: '/ajax/dealers',
				dataType: 'json',
				data: {
					postalCode,
					html: true,
					skuStripped,
					catalog,
					skipSupplierSelectionReporting: isAutomaticSubmission
				},
				success: (data = {}) => {
					handleZipSubmissionSuccess(data);
				},
				statusCode: {
					400: () => {
						zipSubmissionReady();
						handleZipSubmissionError($modalBody.data('error-400'));
					}
				},
				error: () => {
					zipSubmissionReady();
					handleZipSubmissionError($modalBody.data('error-500'));
				}
			});
		}

		function handleClearDealerSuccess() {
			clearError();
			$dealerSelectionModal.modal('hide');
			window.location.reload();
		}

		function handleClearDealer() {
			window.rp_app.request({
				method: 'GET',
				url: '/ajax/dealers/clear',
				dataType: 'json',
				success: (response, status) => {
					if (status === 'success') {
						handleClearDealerSuccess();
					}
				}
			});
		}

		function dealerSelectionWorking() {
			$modalBody.find('.select-dealer-button').addClass('disabled');
		}

		function dealerSelectionReady() {
			$modalBody.find('.select-dealer-button').removeClass('disabled');
		}

		function handleCartFetch() {
			window.rp_app.request({
				type: 'GET',
				url: '/ajax/cart',
				dataType: 'json',
				contentType: 'application/json',
				success: handleCartHasItems,
			});
		}

		function handleCartHasItems(cart) {
			$cartContentList.empty();

			const cartHasItems = !!get(cart, 'itemsCount');
			if (cartHasItems) {
				$changeDealerWarning.removeClass('hidden');

				$dealerConfirmSection.removeClass('hidden');
				$dealerConfirmationFooter.removeClass('hidden');
				$dealerSelectionSection.addClass('hidden');

				const $cartItems = get(cart, 'items');
				$cartItems.forEach(function CartItems_Iterator(item) {
					const $row = document.createElement('div');
					const $title = document.createElement('p');
					const $sku = document.createElement('p');

					$row.className = 'cart-content-row';
					$title.className = 'cart-item-title';
					$sku.className = 'cart-item-sku';
					$title.textContent = get(item, 'title');
					$sku.textContent = get(item, 'product_id');

					$row.append($title);
					$row.append($sku);

					$cartContentList.append($row);
				});

			} else {
				$changeDealerWarning.addClass('hidden');

				$dealerConfirmSection.addClass('hidden');
				$dealerConfirmationFooter.addClass('hidden');
				$dealerSelectionSection.removeClass('hidden');
			}
		}

		function handleDealerSelectionSuccess() {
			clearError();
			dealerSelectionReady();
			$dealerSelectionModal.modal('hide');
			window.location.reload();
		}

		function handleDealerSelectionError(errorMessage) {
			$dealerSelectionError.html(`${errorMessage}`);
			dealerSelectionReady();
		}

		function handleDealerSelection(e) {
			e.preventDefault();

			if (rp$(this).hasClass('disabled')) {
				return;
			}

			const dealerHash = rp$(e.target).data('hash');
			if (!dealerHash) {
				return handleDealerSelectionError($modalBody.data('error-400'));
			}

			clearError();

			// Perform Submission
			dealerSelectionWorking();
			window.rp_app.request({
				method: 'POST',
				url: '/ajax/dealers',
				dataType: 'json',
				data: { dealerHash },
				success: handleDealerSelectionSuccess,
				statusCode: {
					400: () => {
						dealerSelectionReady();
						handleDealerSelectionError($modalBody.data('error-400'));
					}
				},
				error: () => {
					dealerSelectionReady();
					handleDealerSelectionError($modalBody.data('error-500'));
				}
			});
		}

		function handleDealerConfirmSubmit(e) {
			e.preventDefault();

			$dealerConfirmSection.addClass('hidden');
			$dealerConfirmationFooter.addClass('hidden');
			$dealerSelectionSection.removeClass('hidden');
		}

		function isEnterKeyUpEvent(e) {
			return e && (e.type === 'keyup') && (e.which === 13);
		}

		$onReady({
			rp$, window,
			label: 'dealer_selection_modal',
			fn: function () {
				$dealerSelectionModal = rp$('.dealer-selection-modal');
				$dealerSelectionModalTrigger = rp$('.find-dealer-button');
				$modalBody = rp$('.modal-body', $dealerSelectionModal);
				$enterZipButton = rp$('.enter-zip-button', $dealerSelectionModal);
				$dealerSelectionError = rp$('.dealer-selection-errors', $dealerSelectionModal);
				$formErrors = rp$('.form-errors', $dealerSelectionModal);
				$selectedDealerContainer = rp$('.selected-dealer-container', $dealerSelectionModal);
				$dealerSelectionContainer = rp$('.dealer-selection-container', $dealerSelectionModal);
				$dealersListContainer = rp$('.dealers-list-container', $dealerSelectionModal);
				$zipInput = rp$('.zip-input', $dealerSelectionModal);
				$changeDealerWarning = rp$('.change-dealer-warning', $dealerSelectionModal);
				$dealerSelectionSection = rp$('.dealer-selection', $dealerSelectionModal);
				$dealerConfirmationFooter = rp$('.dealer-confirmation-footer', $dealerSelectionModal);
				$dealerConfirmSection = rp$('.dealer-confirm', $dealerSelectionModal);
				$dealerConfirmCancel = rp$('.change-dealer-cancel', $dealerSelectionModal);
				$dealerConfirmSubmit = rp$('.change-dealer-confirm', $dealerSelectionModal);
				$cartContentList = rp$('.cart-content-list', $dealerSelectionModal);

				// To provide product data if we're in the context of a product page
				$productPurchaseModule = rp$('.product-purchase-module');

				// Automatically fetch dealers once initial geolocation complete in main.js
				rp$(document).on('geolocationComplete', handleZipSubmission.bind(this, null, true));

				// Dynamically display $changeDealerWarning
				$dealerSelectionModalTrigger.on('click', handleCartFetch);
				// Handle enter presses when $dealerSelectionModalTrigger is focused
				$dealerSelectionModalTrigger.on('keyup', function handleEnterKeyUp(e) {
					e.preventDefault();

					if (isEnterKeyUpEvent(e) && $dealerSelectionModalTrigger.click) {
						return $dealerSelectionModalTrigger.click();
					}

					return false;
				});

				// Added the modal click event to the submit button itself.
				$enterZipButton.on('click', handleZipSubmission);
				$zipInput.on('keyup', function handleZipEnterKeyed(e) {
					e.preventDefault();

					if (isEnterKeyUpEvent(e)) {
						handleZipSubmission(e);
					}

					return false;
				});

				$selectedDealerContainer .on('click', '.clear-dealer-link', handleClearDealer);

				$modalBody.on('click', '.select-dealer-button', handleDealerSelection);
				$dealerConfirmSubmit.on('click', handleDealerConfirmSubmit);
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
